export const SUMMARY_PANEL_HEIGHT = 480;
